<template>
 <nomination v-if="showNominationForm"/>
  <v-card v-else>
    <v-card-title>
      <h2 class="checkout-h2">{{natalLuz ? 'Termos - Covid-19' : 'Formato do seu ingresso'}}</h2>
    </v-card-title>
    <delivery-panel />
  </v-card>
  
</template>

<script>
import DeliveryPanel from './DeliveryPanel';
import Nomination from '../Nomination/Nomination.vue';
import { mapGetters } from 'vuex';
import moment from 'moment'

export default {
  components: { DeliveryPanel, Nomination },
  created () {
    if (!this.showNominationForm && this.$route.name === 'commissioner') this.$store.dispatch('setCurrentStep', 4)
  },
  computed: {
    ...mapGetters(['nominationStartDate', 'mandatoryNomination', 'eventName']),
    showNominationForm () {
      if (this.natalLuz && this.mandatoryNomination === 0 || this.mandatoryNomination == 2) return false
      if (this.mandatoryNomination === 2) return false
      if (this.mandatoryNomination) return true
      else return moment(this.nominationStartDate, 'YYYY-MM-DD HH:mm:ss').isBefore()
    },
    natalLuz () {
      if (this.eventName && this.eventName.includes('Natal Luz')) {
        return true
      } else return false
    }
  }
};
</script>
